<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Editar Precio Acuerdos Propios</span>
      </v-card-title>
      
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p><strong>Usuario:</strong> {{ user.fullname }}</p>
              <p><strong>Email:</strong> {{ user.email }}</p>
              
              <v-text-field
                v-model="price"
                :label="$t('attrs.own_agreements_price')"
                type="number"
                step="0.01"
                min="0"
                outlined
                :rules="priceRules"
                :error-messages="errorMessages"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" flat @click="cancel">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" :loading="loading" @click="save">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OwnAgreementsPriceDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      price: 0,
      errorMessages: [],
      priceRules: [
        v => !!v || 'El precio es requerido',
        v => !isNaN(parseFloat(v)) || 'Debe ser un número válido',
        v => parseFloat(v) >= 0 || 'El precio debe ser mayor o igual a 0'
      ]
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    value(newVal) {
      if (newVal && this.user) {
        this.price = this.user.own_agreements_price || 0
        this.errorMessages = []
      }
    },

    user(newUser) {
      if (newUser && this.value) {
        this.price = newUser.own_agreements_price || 0
      }
    }
  },

  methods: {
    validate() {
      this.errorMessages = []
      const price = parseFloat(this.price)
      
      if (!this.price) {
        this.errorMessages.push('El precio es requerido')
        return false
      }
      
      if (isNaN(price)) {
        this.errorMessages.push('Debe ser un número válido')
        return false
      }
      
      if (price < 0) {
        this.errorMessages.push('El precio debe ser mayor o igual a 0')
        return false
      }
      
      return true
    },

    save() {
      if (this.validate()) {
        this.$emit('save', parseFloat(this.price))
      }
    },

    cancel() {
      this.price = 0
      this.errorMessages = []
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.headline {
  font-weight: 500;
}
</style>
